export default "__VITE_ASSET__Bl511TXx__"